module.exports = __webpack_public_path__ + "static/media/press.c61c2cb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/press.svg
// module id = 140
// module chunks = 0